import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ErrorHandler, inject, Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { localStorageService } from './localstorage.service';
import { ApiService } from './api.service';
import { SharedService } from './shared.service';

@Injectable()
export class CustomErrorHandlerService extends ErrorHandler {
    headers: any = new HttpHeaders({ 'Content-Type': 'application/json', Accept: '*/*' });
    // constructor(private http: HttpClient, private _local: localStorageService) {
    constructor() {
        super();
    }
    _apiser = inject(ApiService);
    _shared = inject(SharedService);
    private readonly reportedErrors = new Set<string>();
    private readonly MAX_ERROR_CACHE = 50;


    override handleError(error: any) {
        console.log('Chunkload ERROR check', error);
        if ((error + '').includes('ChunkLoadError')) {
            window.location.reload();
        }
        const errors = this.normalizeError(error);
        if (this.isChunkLoadError(error.message)) {
                this.handleChunkLoadError();
            return;
        }
        // Here you can provide whatever logging you want
        // tslint:disable:max-line-length
        super.handleError(error);
        if (this.reportedErrors.has(error.fingerprint)) {
            return;
        }

        this.addToErrorCache(error.fingerprint);

        const apiUrl = environment.baseUrl;
        console.error('Error name:', error);
        if (error instanceof Error) {
            console.error('Error name:', error.name);
            console.error('Message:', error.message);
        }

        this.reportErrorToServer(error);


        // tslint:disable:triple-equals
        // this.http.post<any>(apiUrl + 'frontend_error', { error: String(error) != '[object Object]' ? String(error) : JSON.stringify(error), url: window.location.href }, { headers: this.headers })
        //     .subscribe(response => {
        //     });
    }
    private normalizeError(error: unknown) {
        if (error instanceof Error) {
        return {
            original: error,
            message: error.message || 'Unexpected error occurred',
            stack: error.stack ?? error.message,
            userMessage: error.message || 'Unexpected error occurred',
            fingerprint: error.message, // stable dedupe key
        };
        }

        const message =
        typeof error === 'string'
            ? error
            : JSON.stringify(error ?? 'Unknown error');

        return {
        original: error,
        message,
        stack: message,
        userMessage: message,
        fingerprint: message,
        };
    }
    private addToErrorCache(fingerprint: string): void {
        if (this.reportedErrors.size >= this.MAX_ERROR_CACHE) {
            this.reportedErrors.clear();
        }
        this.reportedErrors.add(fingerprint);
    }
    reportErrorToServer(error: any) {
        const data = {
            error: String(error) != '[object Object]' ? String(error) : JSON.stringify(error),
            url: window.location.href,
            stack: error.stack,
            userAgent: navigator.userAgent,
            timestamp: new Date().toISOString(),
        };
        this._apiser.api(data, 'guest/frontend_error', 'post').subscribe((response: any) => {
            if (response.status == 'error') {
                // console.log('Error reported successfully');
            }
        });
    }
    private isChunkLoadError(message: string): boolean {
    return (
      message.includes('ChunkLoadError') ||
      message.includes('Loading chunk') ||
      message.includes('Failed to fetch dynamically imported module')
    );
  }
    private handleChunkLoadError(): void {
        const reloadAttempted = sessionStorage.getItem('chunk_reload_attempted');

        if (reloadAttempted) {
            console.error('Chunk reload already attempted. Stopping reload loop.');
            this._shared.customPopups(
                'Application failed to load properly. Please clear browser cache and refresh.', 0
            );
            return;
        }

        sessionStorage.setItem('chunk_reload_attempted', 'true');
        this._shared.customPopups('Application updated. Reloading...', 0);

        const global = globalThis as typeof globalThis & {
            caches?: CacheStorage;
        };

        if (global.caches) {
            global.caches.keys()
                .then(keys => Promise.all(keys.map(k => global.caches!.delete(k))))
                .finally(() => {
                    global.location.reload();
                });
        } else {
            global.location.reload();
        }
    }
}
